/**
 * UserDetailContainer
 * --
 */
import React from 'react';
import UserDetailPresenter from './UserDetailPresenter';

const UserDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserDetailPresenter />
    </>
  );
};

export default UserDetailContainer;
